<template>
  <kye-dialog
    width="400px"
    title="员工评价"
    custom-class="kye-comment-dialog"
    :visible.sync="show">
    <div class="kye-comment-dialog__body">
      <p>请对TA的表现进行客观评价</p>
      <div class="kye-comment-dialog__score">
        <img v-for="(item, index) in scoreList" :key="index" :src="item.score === 0 ? scoreGray : score" @click="clickScore(item, index)">
      </div>
      <kye-input type="textarea" :rows="5" v-model="remark" maxlength="30" placeholder="请输入详细说明，以便更好的帮助我们提升公司效率。">
      </kye-input>
    </div>
    <template slot="footer">
      <kye-button type="primary" @click="submit">匿名提交</kye-button>
      <kye-button @click="close">取消</kye-button>
    </template>
  </kye-dialog>
</template>

<script>
  export default {
    data () {
      return {
        loading: false,
        show: false,
        scoreList: [],
        remark: ''
      }
    },
    created () {
      this.score = require('./score.svg')
      this.scoreGray = require('./score-gray.svg')
    },
    methods: {
      init (option) {
        this.form = {
          bizCode: option.bizCode,
          bizId: option.bizId,
          employeeId: option.employeeId,
          permissionCode: option.authCode
        }
        this.scoreList = [
          { score: 0 },
          { score: 0 },
          { score: 0 },
          { score: 0 },
          { score: 0 }
        ]
        this.remark = ''
      },
      async submit () {
        try {
          this.loading = true
          await this.$http('fdb.grade.save', {
            ...this.form,
            score: this.scoreList.reduce((pre, cur) => pre + cur.score, 0),
            remark: this.remark,
          }, { appkey: '50178' })
          this.$message.success('评价成功')
          this.$emit('save')
          this.showDialog(false)
          this.loading = false
        } catch (err) {
          this.loading = false
        }
      },
      close () {
        this.$emit('close')
        this.showDialog(false)
      },
      showDialog (val = true) {
        this.show = val
      },
      clickScore (item, index) {
        this.scoreList.forEach((v, i) => {
          v.score = i <= index ? 1 : 0
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  .kye-comment-dialog {
    &__body {
      > p {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        text-align: center;
      }
    }
    &__score {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 28px 0;
      > img {
        margin-left: 22px;
        width: 32px;
        height: 32px;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-field-comment/comment-dialog.vue